import templateUrl from './publishingAtAGlanceErrors.html';
import './publishingAtAGlanceErrors.scss';

import {createLogger} from '../../../common/logging.config';
const logger = createLogger('publishing-at-a-glance-errors');

class PublishingAtAGlanceErrorsController {
	constructor($rootScope, $scope, publishingErrorService) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.publishingErrorService = publishingErrorService;
		this.entries = [];
		this.errorMessages = [];

		
		this.$onInit = () => {
			this.fetchErrorPublishingJobs();
			//TODO handle error messages from API when available
			//this.errorMessages.push(this.getErrorMessage('OUTAGE'));
		};

		// listen for the event to apply new preferences
		const handler = $rootScope.$on('apply-preferences', (event, payload) => {
			this.fetchErrorPublishingJobs();
		});
		$scope.$on('$destroy', handler);
		
		
	}
	
    getErrorMessage(error) {
    	var errorMessage = {};
		switch (error) {
			case 'OUTAGE': 
				errorMessage.key = "There is a publishing service outage. As soon as service is restored, the following items will publish.";
				break;
			case 'CANCELLATION': 
				errorMessage.key = "Publishing events, routines, or both were cancelled. As a result, content that was scheduled for publishing needs to be rescheduled.";
				break;
			default: 
				errorMessage.key = "";
		}
		return errorMessage;
	}

    // remove the error message specified by the index
    clearErrorMessage(index) {
    	if (this.errorMessages && index < this.errorMessages.length) {
    		this.errorMessages.splice(index, 1);
    	}
	}
	
	fetchErrorPublishingJobs() {
        this.publishingErrorService.getCurrentErrors().then(
    		(data) =>  {
	        	this.entries = data;
	        	this.$scope.$apply();
    		}
		);
	}
	
}

export default {
	controller: [ '$rootScope', '$scope', 'publishingErrorService', PublishingAtAGlanceErrorsController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlanceErrors/publishingAtAGlanceErrors.component.js